<div
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle
  style="
    padding: 5px 5px 5px 10px;
    cursor: pointer;
    background-color: var(--colorBen);
    color: #ffffff;
    font-size: 1.1em;
  "
>
  <div style="display: table; width: 100%">
    <div style="display: table-cell">Swipesum Help Me! Session</div>
    <div style="display: table-cell; text-align: right">
      <input
        type="button"
        value="Close"
        style="margin: 0px; padding: 5px; font-size: 0.9em"
        (click)="this.btnClose_click()"
      />
    </div>
  </div>
</div>

<div style="background-color: #ffffff; padding: 15px">
  @if (this.isSupport && this.sessionId === undefined) {
    <div>
      <p>Begin a new HelpMe! session.</p>
      <div style="text-align: center">
        <input type="button" (click)="this.btnClose_click()" value="Close" />
        <input
          type="button"
          style="margin: 0px"
          (click)="this.btnRequestSession_click()"
          value="Begin session"
        />
      </div>
    </div>
  }

  @if (this.pendingInvite == true) {
    <div>
      <div style="margin-bottom: 15px">
        You have been invited to open a support session:
      </div>
      <div style="text-align: center">
        <input
          type="button"
          style="margin: 0px"
          (click)="this.btnAcceptSession_click()"
          value="Accept"
        />
      </div>
    </div>
  }

  @if (this.sessionId != undefined && this.sessionId != '') {
    <div>
      <div style="text-align: center">
        <input
          type="button"
          style="margin: 0px"
          (click)="this.btnEndSession_click()"
          value="End session"
        />
      </div>
    </div>
  }

  @if (this.sessionEnded == true) {
    <div>
      <p>The session has ended.</p>
      <div style="text-align: center">
        <input
          type="button"
          style="margin: 0px"
          (click)="this.btnClose_click()"
          value="Close"
        />
      </div>
    </div>
  }
</div>
